import { render, staticRenderFns } from "./SetPassword.vue?vue&type=template&id=96f1ab4e&scoped=true"
import script from "./SetPassword.vue?vue&type=script&lang=js"
export * from "./SetPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f1ab4e",
  null
  
)

export default component.exports